var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "21.5 21.508 156.992 156.992",
    viewBox: "0 0 200 200",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M178.492 100.003c0 43.358-35.138 78.497-78.496 78.497-39.208 0-71.718-28.761-77.567-66.351a79.803 79.803 0 0 1-.929-12.145c0-11.793 2.596-22.961 7.258-32.991 12.466-26.871 39.673-45.505 71.238-45.505 43.358-.001 78.496 35.137 78.496 78.495z",
    fill: "#18627D",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.004 88.757c0 12.15-29.694 21.441-29.694 42.03 0 15.734 13.294 24.583 29.694 24.583 16.399 0 29.694-8.849 29.694-24.583-.001-20.589-29.694-29.88-29.694-42.03z",
    fill: "#FDB813",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.659 58.966l17.817 1.429s2.792-.135 2.551 1.766c-.141 1.112-2.225 6.183-8.691 5.764-1.929-.124-8.135.08-8.135.08s-5.587 8.713-10.75 11.577l-10.083.249-7.986-1.38 13.31-12.314 11.967-7.171z",
    fill: "#FFF8E6",
    "data-color": 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.046 71.851c-.333.14-.661.289-.987.441h21.223a26.458 26.458 0 0 0-.987-.441c3.788-2.36 6.227-6.004 6.227-10.104 0-4.604-3.835-4.851-5.737-4.867-1.559-.016-2.969.867-4.951 1.016-1.506.113-1.899-.374-5.162-.463-2.528-.069-3.658.577-5.163.463-1.983-.149-3.394-1.032-4.952-1.016-1.902.016-5.735.263-5.735 4.867-.001 4.101 2.437 7.744 6.224 10.104z",
    fill: "#FDB813",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.162 69.607a4.392 4.392 0 0 0-.749.083H93.054L82.42 74.991l-32.256-.04v30.651l29.829-.011 10.959 5.468 18.555-.037v.002h8.296v-.018l6.69-.16c2.267-.056 4.055-2.271 3.987-4.95-.069-2.605-1.869-4.692-4.059-4.747v-.11c2.583-.24 4.572-2.558 4.504-5.337-.067-2.679-2.035-4.843-4.504-5.092v-.152c2.859-.239 5.07-2.569 4.997-5.347-.066-2.696-2.253-4.861-4.997-5.085v-.179c2.469-.264 4.364-2.57 4.293-5.328-.071-2.894-2.271-5.186-4.917-5.12l-8.635.208z",
    fill: "#FFF8E6",
    "data-color": 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.951 67.012v45.137H22.429a79.803 79.803 0 0 1-.929-12.145c0-11.793 2.596-22.961 7.258-32.991h34.193z",
    fill: "#F85B30",
    "data-color": 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.104 136.021c-.122 4.766-3.093 6.24-6.756 6.275l-.063 2.862-3.178-.07.064-2.887c-2.343-.169-4.115-.582-5.759-1.126l.094-4.251c2.009.219 5.583.448 7.23.485 1.929.068 2.881-.069 2.922-1.908l.018-.823c.032-1.439-.554-2.026-2.318-2.066l-2.679-.059c-4.941-.11-5.883-4.175-5.823-6.854l.031-1.389c.126-5.665 3.523-6.879 6.834-6.806l.06-2.728 3.178.071-.062 2.77c2.718.143 3.678.423 5.825 1.145l-.094 4.226c-1.329-.129-4.601-.427-7.696-.495-1.414-.031-2.553.276-2.585 1.715l-.021.965c-.027 1.198.332 1.921 1.97 1.958l2.579.057c5.964.132 6.313 5.034 6.273 6.864l-.044 2.069z",
    fill: "#F85B30",
    "data-color": 4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.8ba7683cd038c89366fafc3bc4534108.svg";
export { ForwardRef as ReactComponent };